// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,firebase:{
    apiKey: "AIzaSyAKpcfozDMhwDnpuxai9nKLBF2gCLTjD3I",
    authDomain: "fir-project-361bd.firebaseapp.com",
    databaseURL: "https://fir-project-361bd-default-rtdb.firebaseio.com",
    projectId: "fir-project-361bd",
    storageBucket: "fir-project-361bd.appspot.com",
    messagingSenderId: "297139999479",
    appId: "1:297139999479:web:d768d4078904094eb9f9f2",
    measurementId: "G-XTELP515X9"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
